import React from "react"
import { Droppable } from "react-beautiful-dnd"
import { injectIntl } from "react-intl"
import IntlProps from "../../../../state/helpers/IntlProps"
import { DraggableItem } from "./ColumnSelectionModal"
import DraggableItemComponent from "./DraggableItem"

interface OwnProps {
    id: string
    title: string
    list: DraggableItem[]
    enabledTotals: string[]
    onToggleTotal: (id: string) => void
    onRemove: (id: string) => void
}

const DroppableZoneComponent = (props: OwnProps & IntlProps) => {
    return (
        <div>
            <h5>{props.title}</h5>
            <Droppable droppableId={props.id}>
                {(provided, snapshot) => (
                    <div
                        className={`droppable-zone ${snapshot.isDraggingOver ? "dragging-over" : ""}`}
                        ref={provided.innerRef}
                    >
                        {props.list.map((item, i) => (
                            <DraggableItemComponent
                                key={item.id}
                                item={item}
                                index={i}
                                totalChecked={props.enabledTotals?.includes(item.id)}
                                onToggleTotal={() => props.onToggleTotal(item.id)}
                                onRemove={() => props.onRemove(item.id)}
                            />
                        ))}
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
        </div>
    )
}

export default injectIntl(DroppableZoneComponent)


// WEBPACK FOOTER //
// ./src/common/listing/generic-listing/header-selection/DroppableZone.tsx